module.exports = __webpack_public_path__ + "static/media/gcourse2.59a3c7fd.png";